import { Button, Link } from "@fluentui/react-components";
import * as React from "react";
import { IAccentPalette } from "utils/accentPalette";
import { useStyles } from "./dataPrivacyNoticePage.styles";

interface DataPrivacyNoticePageProps {
  onAccept: () => Promise<void> | void;
  termsUrl?: string;
  privacyUrl?: string;
  accentPalette?: IAccentPalette;
}

export const DataPrivacyNoticePage = (
  props: DataPrivacyNoticePageProps,
): JSX.Element => {
  const { accentPalette } = props;
  const [busy, setBusy] = React.useState(false);
  const styles = useStyles();

  const handleContinue = async () => {
    setBusy(true);
    try {
      await props.onAccept();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h1 className={styles.title}>Data Privacy Notice</h1>

        <p className={styles.paragraph}>
          The following is a description and explanation of how information may
          be collected, used, and stored as part of this AI-Driven interview.
          Your responses will be recorded and anonymized. No personal
          identification is requested nor required as part of this AI-Driven
          Interview.
        </p>

        <h2 className={styles.sectionTitle}>
          How we use the information collected:
        </h2>
        <ul className={styles.bulletList}>
          <li className={styles.listItem}>
            Your responses will be recorded and anonymized.
          </li>
          <li className={styles.listItem}>
            Your responses will be processed by our AI systems for analysis
            which may generate follow-up questions as part of the survey.
          </li>
          <li className={styles.listItem}>
            Anonymized and aggregated data will be analyzed and used for
            reporting purposes. Anonymized and aggregated data may be shared
            with your employer.
          </li>
          <li className={styles.listItem}>
            Collected information is not shared or sold to third parties.
          </li>
          <li className={styles.listItem}>
            Collected information is stored securely for 90 days, then
            permanently deleted.
          </li>
          <li className={styles.listItem}>
            Any audio recordings are immediately deleted following
            transcription.
          </li>
          <li className={styles.listItem}>
            Other than as part of generalized actions taken in response to
            insights gathered from this overall exercise, neither the
            information collected nor any processing by artificial intelligence
            will be used to make any decision or take any action about you.
          </li>
        </ul>

        <h2 className={styles.sectionTitle}>Essential Cookies:</h2>
        <p className={styles.paragraph}>
          We use essential cookies to ensure the interview session functions
          properly. These cookies do not collect personal information.
        </p>

        <p className={styles.paragraph}>
          By continuing, you acknowledge you've read and understood this notice.
          Otherwise, please close this browser window.
        </p>

        <hr className={styles.divider} />

        <p className={styles.linksSection}>
          Complete details can be found in our{" "}
          <Link
            href={props.termsUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            Terms of Use
          </Link>{" "}
          and{" "}
          <Link
            href={props.privacyUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            Privacy Statements
          </Link>
          .
        </p>

        <div className={styles.footer}>
          <Button
            appearance="primary"
            onClick={handleContinue}
            disabled={busy}
            className={styles.continueButton}
            style={
              accentPalette
                ? {
                    backgroundColor: accentPalette.accent,
                    color: accentPalette.accentText,
                    borderColor: accentPalette.accent,
                  }
                : undefined
            }
          >
            {busy ? "Please wait..." : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};
